import React, { useEffect, useState } from 'react'
import { IServiceCombinations } from '@raskrask-dk/bookingflow-state-machine'
import { useBFSM } from './bfsmContext'

const defaultValue: IServiceCombinations = {
    serviceTypes: {},
    goals: {},
    basisTypes: {},
    bookingReasons: {},
}

export const ServiceCombinationsContext = React.createContext(defaultValue)

const ProviderServiceCombinations = ({
    children,
}: {
    children: JSX.Element
}): JSX.Element => {
    const [BFSM] = useBFSM()
    const [serviceCombinations, setServiceCombinations] = useState(defaultValue)
    useEffect(() => {
        const getServiceCombinations = async () => {
            const serviceCombinations = await BFSM.repo.getServiceCombinations()
            setServiceCombinations(serviceCombinations)
        }
        getServiceCombinations()
    }, [])

    return (
        <ServiceCombinationsContext.Provider value={serviceCombinations}>
            {children}
        </ServiceCombinationsContext.Provider>
    )
}

const useServiceCombinations = (): IServiceCombinations => {
    const serviceCombinations = React.useContext(ServiceCombinationsContext)
    if (!serviceCombinations)
        throw new Error('Service Combinations must be loaded')
    return serviceCombinations
}

export { ProviderServiceCombinations, useServiceCombinations }
